import { render, staticRenderFns } from "./PaymentMethodAmount.vue?vue&type=template&id=2c0f57a8&scoped=true"
import script from "./PaymentMethodAmount.vue?vue&type=script&lang=js"
export * from "./PaymentMethodAmount.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodAmount.vue?vue&type=style&index=0&id=2c0f57a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f57a8",
  null
  
)

export default component.exports